import React from 'react';
import { classList } from 'utils/componentsCommon';
import PropTypes from 'prop-types';

const ContentBoxFigure = ( { children, figure, className, ...props }) => {
    const classNames = classList(
        'contentBoxFigure',
        className);

    return <section className={ classNames } style={ figure ? { backgroundImage: `url("${figure}")` } : {} } { ...props }>
        { children }
    </section>;
};

ContentBoxFigure.defaultProps = {};
ContentBoxFigure.propTypes = {
    children: PropTypes.node,
    figure: PropTypes.string,
    className: PropTypes.string,
};

export default ContentBoxFigure;
